import { Box, Field, Input, InputGroup, Stack } from '@chakra-ui/react'
import MaskedInput from 'react-text-mask'
import { FormLabel } from 'uikit'

export const InputTime = ({
  name,
  onChange,
  isHideError,
  isInvalid,
  error,
  value,
  label,
  ...props
}) => {
  return (
    <Field.Root invalid={isInvalid}>
      {label && <Field.Label>{label}</Field.Label>}
      <Stack gap={4}>
        <Box>
          <InputGroup>
            <MaskedInput
              mask={[/[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/]}
              id={name}
              value={value}
              render={(ref, props) => <Input id={name} ref={ref} {...props} />}
              onChange={(e) => onChange(e.target.value)}
              {...props}
            />
          </InputGroup>
          {error && isInvalid && !isHideError && (
            <Box fontSize="0.7rem" color="red.500" mt="4px">
              {error}
            </Box>
          )}
        </Box>
      </Stack>
    </Field.Root>
  )
}
